import { v4 as uuidv4 } from 'uuid'
import toSnakeCaseStringUtil from './to-snake-case'

const queryString = require('query-string')

export function getUrlWithQueryStringUtil (urlParam, queryParam = {}) {
  const {
    url,
    query
  } = queryString.parseUrl(urlParam)

  return `${url}?${queryString.stringify({ ...query, ...queryParam })}`
}

export function parseQueryParamsFromUrlStringUtil (url) {
  return queryString.parse(url)
}

export function getLastSegment (str, separator = '.') {
  return str.split(separator).pop()
}

export function getFileTypeStringUtil (str) {
  return getLastSegment(str)
}

export function getFilenameStringUtil (uri) {
  return getLastSegment(uri, '/')
}

export function getExtensionStringUtil (filename) {
  return `.${getFileTypeStringUtil(filename)}`
}

export function joinPathsStringUtil (...paths) {
  return paths.join('.')
}

export function joinUrlSegmentsStringUtil (...paths) {
  return paths.join('/')
}

export function generateUuidStringUtil () {
  return uuidv4()
}

export function toLowerCaseStringUtil (str = '') {
  return str.toLowerCase()
}

/**
 * Converts the given `value` to an url-slug.
 * @param  {String} value
 * @returns {String}
 */
// export function toSlugStringUtil (value) {
//   return value
//     .toLowerCase()
//     .replace(/-|&/g, ' ')
//     .replace(/ /g, '-')
//     .replace(/[^\w-]+/g, '')
// }

/**
 * Converts the given `value` to a string.
 * @param  {String} value
 * @returns {String}
 */
export function fromSlugToString (value, separator = '') {
  return value
    .toLowerCase()
    .replace(/-/g, ' ')
}

export function getLastSegmentFromString (str = '', separator = '/') {
  if (typeof str !== 'string') {
    str = str + ''
  }
  const segments = str.split(separator)
  return segments[segments.length - 1]
}

export function capitalizeStringUtil (str) {
  str = str || ''
  if (!str) {
    return str
  }
  return str[0].toUpperCase() + str.slice(1)
}

export function joinStrReduxUtil (...strings) {
  return `${capitalizeStringUtil(strings.map(str => (
    str + ''
  )
    .replace(/_/g, ' '))
    .join(' '))}`
}

export function joinUpperCaseUnderscoreStringUtil (...strings) {
  if (!strings || !strings.length) {
    return strings
  }
  return `${strings.map(key => toSnakeCaseStringUtil(key + '')
    .toUpperCase())
    .join('_')}`
}

export * from './get-joined-paths'
export * from './get-name-from-email'
export { default as capitalizeEachWordStringUtil } from './capitalize-each-word'
export { default as isEmailStringUtil } from './is-email'
export * from './remove-numbers'
export * from './get-first-name-from-email'
export * from './get-last-name-from-email'
export * from './get-email-local-part'
export * from './interpolate'
export * from './random'
export {
  default as trimExtraSpacesStringUtil
} from './trim-spaces'
export * from './to-slug'
export * from './is-private-email'
export {
  default as getPathWithQueryParamsStringUtil
} from './get-path-with-query-params'
export {
  default as toSnakeCaseStringUtil
} from './to-snake-case'

/*
** 'Anastasia Beverly Hills'
 */
export function getQueryElements (query) {
  const queryElements = []
  const words = query.split(' ')
  words.forEach(word => {
    let previousQuery = ''
    for (let i = 0; i < word.length; word[i]) {
      previousQuery += word[i]
      queryElements.push(previousQuery)
      i += 1
    }
  })
  return queryElements
}
